export const stickyNoteColor = Object.freeze([
  { key: 1, value: 'Orange' },
  { key: 2, value: 'Light Yellow' },
  { key: 3, value: 'Green' },
  { key: 4, value: 'Light Blue' },
  { key: 5, value: 'Dark Blue' },
  { key: 6, value: 'Purple' },
  { key: 7, value: 'Pink' },
]);
